(ns dre.modals.my-searches.tags.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.my-searches.tags.events :as t-events]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :my-searches :tags])

;; events

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [opts]]
  {:db opts}))

(rf/reg-event-fx
 ::delete
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [data]]
  {:fx [[:dispatch [::modals/clear]]
        [:dispatch [::t-events/delete data]]]}))

(rf/reg-event-fx
 ::update-data-copy
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [path value]]
  {:db (assoc-in db (cons :data-copy path) value)}))

(rf/reg-event-fx
 ::copy
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [data]]
  {:fx [[:dispatch [::t-events/copy (:tag_uuid data) (:copy-name data)]]]}))

(rf/reg-event-fx
 ::update-data-edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [path value]]
  {:db (assoc-in db (cons :data-edit path) value)}))

(rf/reg-event-fx
 ::edit
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [data]]
  {:fx [[:dispatch [::t-events/edit (:tag_uuid data) (:name data) (:description data) (:color data) (:source+uris data) (:after-fx data)]]]}))

;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))

(rf/reg-sub
 ::data-delete
 :<- [::state]
 (fn [db _]
   (get db :data-delete)))

(rf/reg-sub
 ::data-copy
 :<- [::state]
 (fn [db _]
   (get db :data-copy)))

(rf/reg-sub
 ::data-edit
 :<- [::state]
 (fn [db _]
   (get db :data-edit)))
